import API from '../../../../services/API';

export const setSupportMeasures = (data) => {
  return API.request({
    url: '/mobilization/privilegesAbsence',
    method: 'POST',
    data,
  });
};

export function getPrivileges() {
  return API.request({
    method: 'GET',
    url: '/mobilization/privileges',
  });
}
